import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <h3>Get In Touch</h3>
      <h4>
        If you are in need of any help or guidance, feel free to reach us on our
        email address: uoaferrywave@gmail.com. You can also find us on Instagram
        - @ferrywaveuoa
      </h4>
    </div>
  );
};

export default Footer;
